import _ from "lodash";
import moment from "moment";

const getInvoiceExtraDetails = (invoice) => {
    const invoiceType = invoice.type;
    if (invoiceType === "wallet-deposit") {
        return [
            {
                title: "Wallet Deposit",
                price: invoice.price,
                items: [
                    {
                        title: "Wallet Deposit",
                        price: invoice.price,
                    },
                ],
            },
        ];
    }
};

const extraFields = {
    storage: "Storage",
    "ai-usage": "AI Usage (Base Token Usage)",
};

const getInvoiceDetails = (invoice, untilToday = false) => {
    if (Object.keys(invoice.details || {}).length === 0) {
        return {
            paid: invoice.paid,
            prices: {
                price: invoice.price,
                taxPrice: invoice.price * invoice.vatRate,
                totalPrice: invoice.price + invoice.price * invoice.vatRate,
            },
            period: "",
            plans: getInvoiceExtraDetails(invoice) || [],
        };
    }
    const plans = invoice.details.planActions;
    const timeBuckets = invoice.details.timeBuckets;
    const priceDetail = invoice.details.priceDetail;

    const mergePrice = (oldVal = 0, newVal) => {
        return oldVal + newVal;
    };

    const getChatbotSessionCount = (plan) => {
        const feature = plan.features.find((feature) => feature.type === "chatbot");
        return _.get(feature, "maxSessionCount", 0);
    };
    const bucketMerged = Object.keys(timeBuckets).reduce((acc, planType) => {
        const buckets = timeBuckets[planType];
        buckets.forEach((bucket) => {
            const plan = _.get(plans, `${bucket.planActionId}.target`);
            const planAction = _.get(plans, `${bucket.planActionId}.data`);
            const channelCount =
                _.get(planAction, "details.whatsappChannel") ||
                _.get(planAction, "details.instagramChannel") ||
                _.get(planAction, "details.messengerChannel") ||
                _.get(planAction, "details.trendyolChannel") ||
                _.get(planAction, "details.metaLeadChannel");
            const agentCount = _.get(planAction, "details.agentCount", 0);
            const sessionCount = _.get(plan, "type") === "chatbot" ? getChatbotSessionCount(plan) : 0;
            acc[bucket.planActionId || planType] = {
                planType,
                title: plan ? `${plan.title} ${plan.altTitle}` : extraFields[planType],
                isFreePlan: _.get(plan, "isFreePlan", false),
                startDate: _.get(acc[bucket.planActionId], "startDate", bucket.date),
                endDate: bucket.date,
                price: mergePrice(
                    _.get(acc[bucket.planActionId || planType], "price"),
                    _.get(bucket, "details.acceptPrice", _.get(bucket, "details.dailyPrice", 0)),
                ),
                details: Object.assign({}, bucket.details, {
                    channelCount: _.get(bucket, "details.channelCount", channelCount),
                    agentCount: _.get(bucket, "details.agentCount", agentCount),
                    totalChatbotSessionCount: _.get(bucket, "details.totalChatbotSessionCount", sessionCount),
                }),
                /*   totalChatbotSessionCount: _.get(bucket, "details.totalChatbotSessionCount", sessionCount),
                   todayUsedSessionCount: mergePrice(
                       _.get(acc[bucket.planActionId || planType], "todayUsedSessionCount"),
                       _.get(bucket, "details.todayUsageSessionCount", 0)
                   ),
                   totalChatbotFreeSessionCount: _.get(bucket, "details.freeSessionCount", 0),
                   todayUsedFreeSessionCount: mergePrice(
                       _.get(acc[bucket.planActionId || planType], "todayUsedFreeSessionCount"),
                       _.get(bucket, "details.todayFreeUsageSessionCount", 0)
                   ),
                   totalChatbotExtraSessionCount: _.get(bucket, "details.extraSessionCount", 0),
                   todayUsedExtraSessionCount: mergePrice(
                       _.get(acc[bucket.planActionId || planType], "todayUsedExtraSessionCount"),
                       _.get(bucket, "details.todayExtraUsageSessionCount", 0)
                   ),*/
            };
        });
        return acc;
    }, {});

    const groups = Object.values(bucketMerged).reduce((acc, bucket) => {
        const key = bucket.planType;
        if (!acc[key]) {
            acc[key] = {
                title: key
                    .split("-")
                    .map((word) => _.capitalize(word))
                    .join(" "),
                price: 0,
                items: [],
            };
        }
        const price = +bucket.price.toFixed(2);
        acc[key].items.push(
            Object.assign({}, bucket, {
                price,
                startDate: bucket.startDate && moment(bucket.startDate).format("MMM DD, YYYY"),
                endDate: bucket.startDate && moment(bucket.endDate).format("MMM DD, YYYY"),
            }),
        );
        acc[key].price += price;
        return acc;
    }, {});

    const prices = Object.values(priceDetail || {}).reduce(
        (acc, price) => {
            acc.price += price.price;
            acc.taxPrice += price.taxPrice;
            acc.totalPrice += price.totalPrice;
            return acc;
        },
        {
            price: 0,
            taxPrice: 0,
            totalPrice: 0,
        },
    );

    const startDate = moment(invoice.createdDate).format("MMM DD, YYYY");
    const endDate =
        ["manuel", "monthly"].includes(invoice.type ) ? untilToday ? ` - ${moment().format("MMM DD, YYYY")}` : ` - ${moment(invoice.createdDate).endOf("month").format("MMM DD, YYYY")}` : "";
    return {
        paid: invoice.paid,
        prices,
        period: `${startDate}${endDate}`,
        plans: Object.values(groups).sort((a, b) => b.price - a.price),
    };
};

exports.getDetailInvoice = getInvoiceDetails;
